<div class="row mt-5 justify-content-end mb-4">
  <div class="col-md-6">
      <div class="row mt-2">
          <div class="col-md-2">Ukupno duguje:</div>
          <div class="col-md-3 text-right font-weight-bold border">{{ukupnoDuguje}}</div>
          <div class="col-md-2">Ukupno potražuje:</div>
          <div class="col-md-3 text-right font-weight-bold border">{{ukupnoPotrazuje}}</div>
      </div>
    </div>
</div>